var UsersSharedAppsService = /** @class */ (function () {
    function UsersSharedAppsService(api) {
        var _this = this;
        this.fetchUsersSharedApps = function (appId) { return _this.API.get("/apps/".concat(appId, "/user_share")); };
        this.createUsersSharedApp = function (appId, usersSharedAppId) {
            return _this.API.post("/apps/".concat(appId, "/user_share/").concat(usersSharedAppId));
        };
        this.deleteUsersSharedApp = function (appId, usersSharedAppId) {
            return _this.API.delete("/apps/".concat(appId, "/user_share/remove/").concat(usersSharedAppId));
        };
        this.getUsersSharedByApps = function (appId) {
            return _this.API.get("/apps/".concat(appId, "/user_share/child_apps"));
        };
        this.API = api;
    }
    return UsersSharedAppsService;
}());
export { UsersSharedAppsService };
